import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { Spinner } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { TypedMemo } from '../../../common/types';
import { soundCloudReturnMessages as m } from './soundCloudReturnMessages';
import { withBrandWord } from '../../../music24/components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for SoundCloudReturn; each part uses its own slice of it */
import styles from './SoundCloudReturn.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The three steps of the working page (design b1). No button while it works. */
const SoundCloudReturnStepsComponent: React.FC = () => {
  const intl = useIntl();
  return (
    <ol className={styles.steps} aria-busy="true">
      <li>
        <span className={clsx(styles.stepDot, styles.stepDone)}>
          <FontAwesomeIcon icon={faCheck} />
        </span>
        {withBrandWord(intl.formatMessage(m.stepAllowed))}
      </li>
      <li>
        <Spinner size="sm" />
        {intl.formatMessage(m.stepSaving)}
      </li>
      <li className={styles.stepWaiting}>
        <span className={styles.stepDot} />
        {intl.formatMessage(m.stepProfile)}
      </li>
    </ol>
  );
};

export const SoundCloudReturnSteps = TypedMemo(SoundCloudReturnStepsComponent);
